var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.event.isPublished && _vm.event.hasTestSubmissions && _vm.event.hasAnyItemsWithLimitedCapacityEnabled)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Your event is in DRAFT mode. Test submissions do not impact limited availability and capacity limits.\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }